import { isValidLink as e, sanitizeLink as t } from "../../shared/isValidLink.es.js";
import { r as n } from "../../chunks/index.es.wVhS2yfK.js";
import { useRef as r, useState as i } from "react";
import { Link2OffIcon as a, LinkIcon as o, UnlinkIcon as s } from "lucide-react";
import { Fragment as c, jsx as l, jsxs as u } from "react/jsx-runtime";
import { Editor as d, Element as f, Transforms as p } from "slate";
import { ReactEditor as m, useSlateStatic as h } from "slate-react";
// lib/Link/components/EditLink.tsx
var g = ({ entry: d }) => {
	let f = h(), [g, v] = d || [], [y, b] = i(n.isElement(g) && typeof g?.properties?.url == "string" ? g.properties.url : ""), x = r(null), [S, C] = i(!1);
	return n.isElement(g) ? /* @__PURE__ */ u("div", {
		className: "flex -ml-1 select-none content-center gap-x-1",
		children: [
			/* @__PURE__ */ l("div", {
				className: "p-2 w-8 h-8 select-none flex place-items-center rounded border border-white hover:bg-gray-100 hover:border-gray-200 pointer data-[state='active']:bg-gray-100 data-[state='active']:border-gray-200 dark:border-gray-900 dark:hover:bg-slate-800 dark:hover:border-slate-700 dark:data-[state='active']:bg-gray-800 dark:data-[state='active']:border-slate-800 dark:hover:data-[state='active']:border-slate-700",
				onMouseDown: (e) => {
					e.preventDefault(), _(f);
				},
				children: /* @__PURE__ */ l(a, {})
			}),
			/* @__PURE__ */ l("input", {
				className: "pl-2 pr-8 text-sm border justify-center select-none rounded bg-slate-50 dark:bg-slate-800 dark:border-slate-700",
				id: g.id,
				ref: x,
				type: "text",
				value: y,
				onFocus: () => {
					C(!0);
				},
				onMouseDownCapture: (e) => {
					e.stopPropagation(), e.preventDefault(), e.currentTarget.focus();
				},
				onChange: (e) => {
					b(e.target.value);
				},
				onKeyDown: (e) => {
					(e.key === "Escape" || e.key === "Enter") && (e.preventDefault(), e.stopPropagation(), m.focus(f));
				},
				onBlur: () => {
					if (!S) return;
					let e = t(y);
					e === "" ? _(f) : p.setNodes(f, { properties: {
						...g.properties,
						url: e
					} }, { at: v });
				}
			}),
			e(y, !0) ? /* @__PURE__ */ l("a", {
				href: y,
				target: "_blank",
				rel: "noopener noreferrer",
				className: "p-2 w-8 h-8 -ml-9 select-none flex place-items-center",
				children: /* @__PURE__ */ l(o, { className: "text-green-600" })
			}) : /* @__PURE__ */ l("div", {
				className: "p-2 w-8 h-8 -ml-9 select-none flex place-items-center",
				onMouseDown: (e) => {
					e.preventDefault(), e.stopPropagation();
				},
				children: /* @__PURE__ */ l(s, { className: "text-red-600" })
			})
		]
	}) : /* @__PURE__ */ l(c, {});
}, _ = (e) => {
	p.unwrapNodes(e, { match: (e) => !d.isEditor(e) && f.isElement(e) && e.type === "core/link" });
};
export { g as EditLink };
